export const EVENT_STOCKUNIT_ADD_INIT = 'STOCKUNIT_ADD_INIT'

export const EVENT_STOCKUNIT_UPDATE_INIT = 'STOCKUNIT_UPDATE_INIT'

export const EVENT_STOCKUNIT_UPDATE_SUCCESS = 'STOCKUNIT_UPDATE_SUCCESS'

export const EVENT_STOCKUNIT_DETAIL_INIT = 'STOCKUNIT_DETAIL_INIT'

export const EVENT_STOCKUNIT_DELETE_INIT = 'STOCKUNIT_DELETE_INIT'
